const getIsHK = countryCode => countryCode === 'HK'

export default getIsHK
